import React, { useState, useEffect } from 'react';
import { useGame } from '../../context/GameContext';
import { usePlayer } from '../../context/PlayerContext';
import { TURN_PHASES } from '../../utils/gameRules';
import { getDrawPhaseMessage, getDecisionPhaseMessage, getOpponentTurnMessage } from '../../utils/flavorText';

function PlayerTurnIndicator() {
  const { state } = useGame();
  const { playerId } = usePlayer();
  const { currentTurn, players } = state;
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!currentTurn) {
      setMessage('');
      return;
    }

    const isMyTurn = currentTurn.playerId === playerId;
    const currentPlayer = players[currentTurn.playerId];
    const name = currentPlayer?.displayName || 'Unknown';

    if (isMyTurn) {
      if (currentTurn.phase === TURN_PHASES.WAITING_DRAW) {
        setMessage(getDrawPhaseMessage());
      } else {
        setMessage(getDecisionPhaseMessage());
      }
    } else {
      setMessage(getOpponentTurnMessage(name));
    }
  }, [currentTurn?.playerId, currentTurn?.phase, currentTurn?.turnNumber, playerId, players]);

  if (!message) return null;

  const isMyTurn = currentTurn?.playerId === playerId;

  return (
    <div className={`turn-indicator ${isMyTurn ? 'turn-indicator--active' : ''}`}>
      {message}
    </div>
  );
}

export default PlayerTurnIndicator;
